import { render, staticRenderFns } from "./OncoClass.vue?vue&type=template&id=21325e72&"
import script from "./OncoClass.vue?vue&type=script&lang=js&"
export * from "./OncoClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports